export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20artistic%20flat%20lay%20composition%20with%20pastel%20toned%20fashion%20accessories%20including%20minimal%20sneakers%2C%20a%20woven%20bag%2C%20and%20delicate%20gold%20jewelry%20pieces%20scattered%20on%20a%20cream%20textured%20surface%2C%20warm%20morning%20sunlight%20creating%20long%20gentle%20shadows%2C%20abstract%20aesthetic%20with%20sage%20green%20and%20blush%20accents%2C%20dreamy%20editorial%20photography%20with%20soft%20focus%20edges%20and%20luminous%20airy%20atmosphere&width=1920&height=1080&seq=sugargoo-hero-v2-01&orientation=landscape"
          alt="Sugargoo Spreadsheet Lifestyle Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs md:text-sm text-white font-medium">Updated Daily • 14 Categories • 5000+ Finds</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
          Sugargoo Spreadsheet
          <br />
          <span className="text-3xl md:text-5xl lg:text-6xl font-normal italic opacity-90">2026</span>
        </h1>

        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Find the best products, compare prices, and shop smarter with the most comprehensive Sugargoo Spreadsheet database. Your ultimate gateway to trending fashion, streetwear, and accessories.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-accent-500 hover:bg-accent-600 text-white font-semibold text-base px-8 py-3.5 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-accent-500/25"
          >
            Buy It Now
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-semibold text-base px-8 py-3.5 rounded-full border border-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-12">
          {['Updated Daily', 'Beginner Friendly', 'Product Comparisons', 'Safe Shopping'].map((badge) => (
            <div key={badge} className="flex items-center gap-2 text-white/70 text-sm">
              <i className="ri-check-line text-accent-400 text-base w-5 h-5 flex items-center justify-center"></i>
              {badge}
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/40 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 rounded-full bg-white/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}